export enum SuspendUpdateTypeEnum {
    DAILY = 'Daily',
    WEEKDAY = 'WeekDay',
    SPECIFIC_DATES = 'Specific Dates'
}
